<template>
    <v-app>
        <v-app-bar
            app
            color="#007CA4"
            dark
        >
        <div class="d-flex align-center">
          <v-img
            alt="Vuetify Logo"
            class="shrink mr-2"
            contain
            src="https://cdn.vuetifyjs.com/images/logos/vuetify-logo-dark.png"
            transition="scale-transition"
            width="40"
          />
          <h2>TestPanel: v{{botonera_version}}</h2>
        </div>
  
        <v-spacer></v-spacer>
        <div style="color:white">AlisonJS: v{{alisonJS_version}}  |  AlisonGUI: v{{alisonGUI_version}}</div>
        <v-spacer></v-spacer>
  
  
        <v-btn
          href="https://certisur.atlassian.net/wiki/spaces/ASP/pages/1146992/Alison+JS"
          target="_blank"
          text
        >
          <span class="mr-2">docs & download</span>
          <v-icon>mdi-open-in-new</v-icon>
        </v-btn>
      </v-app-bar>
      <v-main style="background-color:rgba(255,255,255,0.5)">
        <div style="position:relative;background-color:rgba(255,255,255,0.7);height: 100%;">
          <AlisonLibComponent />
        </div>
      </v-main>
      <v-footer color="#007CA4">
        <v-spacer></v-spacer>
      </v-footer>
    </v-app>
</template>

<script>
import AlisonLibComponent from '../AlisonLibComponent';
import alisonJS from  '@/services/alison_js.js'
import alisonGUI from  '@/services/alison_gui.js'
import * as pack from '../../package.json';

export default {
name: 'App',
components: {
    AlisonLibComponent
},
data: () => {
    return{
    provider: 'DESKTOP',
    version: '',
    guiVersion: '',
    items: [
            { title: 'DESKTOP' },
            { title: 'SERVER' },
        ],
        }
},
created(){
    this.alisonGUI_version = alisonGUI.version;
    this.alisonJS_version = alisonJS.version;
    this.botonera_version = pack.version;
},
methods: {

}
};
</script>
